//https://github.com/ngneat/svg-icon?tab=readme-ov-file#icon-sizing
import { Sizes } from '@agilox/ui-common';

export const IconSizeConfig = {
	sizes: {
		'2xs': '7px',
		[Sizes.XS]: '14px',
		[Sizes.S]: '18px',
		[Sizes.M]: '20px',
		[Sizes.L]: '24px',
		[Sizes.XL]: '30px',
		[Sizes['2XL']]: '38px',
		[Sizes['3XL']]: '56px',
	},
	defaultSize: Sizes.S,
};
